/* FOODHUB - CTA bar fixe sur /pages/avea + clic produit */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function init() {
    if (location.pathname.replace(/\/$/, '') !== '/pages/avea') return;
    if (document.querySelector('.fh-brand-cta-fixed')) return;

    var CTA_PRIMARY = '/pages/contact';
    var CTA_PRO = '/pages/devenir-client-pro-restaurants-traiteurs-epiceries-fines';

    var bar = document.createElement('div');
    bar.className = 'fh-brand-cta-fixed';
    bar.innerHTML = ''
      + '<a class="primary" href="' + CTA_PRIMARY + '">DEMANDER UN DEVIS AVÉA →</a>'
      + '<a href="' + CTA_PRO + '">DEVENIR CLIENT PRO</a>';
    document.body.appendChild(bar);

    var prods = document.querySelectorAll('.fh-brand .fh-product');
    prods.forEach(function (p) {
      if (p.dataset.clickInit) return;
      p.dataset.clickInit = '1';
      p.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        window.location.href = CTA_PRIMARY;
      });
    });

    prods.forEach(function (p) {
      if (p.querySelector('.fh-prod-cta-inline')) return;
      var cta = document.createElement('a');
      cta.className = 'fh-prod-cta-inline';
      cta.href = CTA_PRIMARY;
      cta.textContent = 'DEMANDER UN DEVIS POUR CETTE PIÈCE →';
      cta.style.cssText = 'display:inline-block;margin-top:12px;padding:10px 18px;background:#B8985A;color:#1A1208;border-radius:999px;font-size:11px;letter-spacing:0.14em;font-weight:700;text-decoration:none;';
      p.appendChild(cta);
    });
  }
  ready(init);
})();
